export default axios => ({
  getList (payload) {
    return axios.get('/filter-push/index', payload)
  },
  view (id) {
    return axios.get(`/filter-push/view/${id}`)
  },
  getQuestionnaireList () {
    return axios.get('/filter-push/questionnaire-list')
  },
  getMobileScreens (payload) {
    return axios.get('/filter-push/mobile-screens', payload)
  },
  countUser (payload) {
    return axios.post('/filter-push/count-users', payload)
  },
  create (payload) {
    return axios.post('/filter-push/create', payload)
  },
  send (payload, id) {
    return axios.get(`/filter-push/send/${id}`, payload)
  },
  update (payload, id) {
    return axios.post(`/filter-push/update/${id}`, payload)
  }
})
